import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-observeSop-evaluation',
  templateUrl: './observeSop.component.html',
  styleUrls: ['./observeSop.component.css']
})
export class ObserveSopComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  onChildData(event :any){
    this.router.navigate([event]);
    }
}
